import { render, staticRenderFns } from "./CreateSupportPartnerProfile.vue?vue&type=template&id=144ce1da&"
import script from "./CreateSupportPartnerProfile.vue?vue&type=script&lang=js&"
export * from "./CreateSupportPartnerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports